<!--  -->
<template>
    <el-dialog class="formDialog" title="为了后期更好的服务请填写您的相关信息。" width="542px" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible">
        <el-form ref="form">
            <div class="form_item" v-for="(item, index) in formlist" :key="index">
                <el-form-item>
                    <p class="colname" :class="{'require': item.isnotnull}">{{item.colname}}</p>
                    <el-input v-model="item.colvalue" v-if="item.coltype === 1"></el-input>
                    <el-radio-group v-model="item.colvalue" v-else-if="item.coltype === 6">
                        <el-radio :label="options" v-for="(options, i) in item.optionsinfo" :key="i"></el-radio>
                    </el-radio-group>
                    <el-checkbox-group v-model="item.colvalue" v-else-if="item.coltype === 7">
                        <el-checkbox :label="options" v-for="(options, i) in item.optionsinfo" :key="i"></el-checkbox>
                    </el-checkbox-group>
                    <el-select v-model="item.colvalue" v-else-if="item.coltype === 8">
                        <el-option :label="options" v-for="(options, i) in item.optionsinfo" :value="options" :key="i"></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="btn">
                <el-button type="primary" @click="submitMsg">提交信息</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            formlist: []
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open(arr) {
            if (!this.formlist.length) {
                let formlist = JSON.parse(JSON.stringify(arr))
                formlist.forEach((item) => {
                    if (item.coltype === 1 || item.coltype === 6 || item.coltype === 8) {
                        item.colvalue = ''
                    } else {
                        item.colvalue = []
                    }
                    if (item.coltype !== 1) {
                        item.optionsinfo = item.optionsinfo.split(',')
                    }
                })
                this.formlist = JSON.parse(JSON.stringify(formlist))
            }
            this.dialogVisible = true
        },
        submitMsg() {
            let flag = true
            this.formlist.some((item) => {
                if (item.isnotnull === 1) {
                    if (!item.colvalue.length) {
                        this.$message.error(`${item.colname}为必填`)
                        flag = false
                        return true
                    }
                }
            })
            if (flag) {
                const arr = []
                this.formlist.forEach((obj) => {
                    const colinnerid = obj.colinnerid
                    let colvalue = ''
                    if (obj.coltype === 7) {
                        colvalue = obj.colvalue.join(',')
                    } else {
                        colvalue = obj.colvalue
                    }
                    arr.push({colinnerid, colvalue})
                })
                this.$emit('fillInOver', arr)
                this.dialogVisible = false
            }
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .formDialog {
        .el-dialog__header {
            .el-dialog__title {
                font-size: 14px;
                color: #666666;
            }
        }
        .el-dialog__body {
            padding: 10px 20px 20px;
            .el-form {
                .el-form-item {
                    margin-bottom: 14px;
                    .colname {
                        font-size: 14px;
                        color: #333333;
                        margin-bottom: 14px;
                        line-height: 16px;
                        &.require::after {
                            content: '*';
                            color: #F56C6C;
                            margin-bottom: 4px;
                        }
                    }
                    .el-select {
                        width: 100%;
                    }
                }
                .btn {
                    padding-top: 16px;
                    display: flex;
                    justify-content: center;
                }
            }
        }
    }
</style>